import {
  useQuery,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import * as api from '../api/alerts';
import { useBusinessUuid } from '../useBusinessUuid';

export const useUnreadAlerts = () =>
  useQuery({
    queryKey: ['alerts', { unreadOnly: true }],
    queryFn: () =>
      api
        .getAlertsPaginated({ unreadOnly: true, page: 1, limit: 100 })
        .then((r) => r.data),
    refetchInterval: 60000,
  });

export const useAlertsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['alerts', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getAlertsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useMarkAlertRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.markAlertRead(uuid),
    onSettled: () => qc.invalidateQueries({ queryKey: ['alerts'] }),
  });
};

export const useMarkAllAlertsRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.markAllAlertsRead(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alerts'] }),
  });
};

export const useCheckAlerts = () => {
  const qc = useQueryClient();
  const businessUuid = useBusinessUuid();
  return useMutation({
    mutationFn: () => {
      if (!businessUuid) throw new Error('No business selected');
      return api.checkAlerts(businessUuid);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alerts'] }),
  });
};
